const API_BASE = process.env.VIRGIL__API_URL || '';
 
export function apiFetch(path, options = {}) {
  return fetch(`${API_BASE}${path}`, options);
} 